import React, { useState } from "react";

/// Scroll
import PerfectScrollbar from "react-perfect-scrollbar";
import {RecaputalitifExamen, RecaputalitifRevision} from "./Recapitulatifs";
import './Exams.css'
import '../../css/siamois.css'


/// Components
// import Notes from "../../../jsx/components/chatBox/Notes";
// import Alerts from "../../../jsx/components/chatBox/Alerts";
// import Chat from "../../../jsx/components/chatBox/Chat";

export const RecapitulatifBoxRevision = ({ onClick, toggle , howManyQuestions ,userScore , actualQuestionIndex }) => {
    const [toggleTab, settoggleTab] = useState(
        window.location.hash.slice(1) ? window.location.hash.slice(1) : "chat"
    );

    const dataToggle = [
        { href: "#notes", name: "Notes" },
        { href: "#alerts", name: "Alerts" },
        { href: "#chat", name: "Chat" },
    ];

    return (
        <div id="QuestionStats" style={{zIndex : 9999}} className={`chatbox ${toggle === "QuestionStats" ? "active" : ""}`}>
            <div className="chatbox-close" onClick={() => onClick()}></div>
            <RecaputalitifRevision howManyQuestions={howManyQuestions} userScore={userScore} actualQuestionIndex={actualQuestionIndex}/>
        </div>
    );
};

export const RecapitulatifBoxExamen = ({ onClick, toggle }) => {
    const [toggleTab, settoggleTab] = useState(
        window.location.hash.slice(1) ? window.location.hash.slice(1) : "chat"
    );

    const dataToggle = [
        { href: "#notes", name: "Notes" },
        { href: "#alerts", name: "Alerts" },
        { href: "#chat", name: "Chat" },
    ];

    return (
        <div id="QuestionStats" style={{zIndex : 9999}} className={`chatbox ${toggle === "QuestionStats" ? "active" : ""}`}>
            <div className="chatbox-close" onClick={() => onClick()}></div>
            <RecaputalitifExamen/>
        </div>
    );
};

